import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import { cacheDuration } from '../../shared'
import { useQueryKeys } from '../useQueryKeys'
import { listAll } from '~/utils'
import { getApiClient } from '../../stores'

type Props = {
  conversationId: string
  botId: string
  workspaceId: string
}

export function useConversationParticipants({ conversationId, botId, workspaceId }: Props) {
  const queryKeys = useQueryKeys()

  return useQuery({
    queryKey: queryKeys.listConversationParticipants(conversationId, botId, workspaceId),
    queryFn: () => listAll(getApiClient({ workspaceId, botId }).listUsers, { conversationId }, ({ users }) => users),
    staleTime: cacheDuration.short,
    meta: {
      errorMessage: "Sorry, we couldn't load users at this time.",
    },
  })
}
